import styled from 'styled-components'

export const Form = styled.div`
  margin-top: 32px;
  width: 80%;
  display: flex;
  align-items: center;
  gap: 57px;
  margin-bottom: 32px;
  flex-shrink: 0;
`

export const DataOverview = styled.div`
  display: grid;
  grid-template-columns: 0.7fr 1fr;
  gap: 2px 40px;
`

export const HeadingWrapper = styled(DataOverview)`
  grid-template-columns: 0.7fr 0fr;
  padding-right: 30px;
`
export const Edit = styled.p`
  align-self: center;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.font.semiBold};
  font-size: ${({ theme }) => theme.font.sizes.medium};
  text-decoration: underline ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 20px;
    height: 20px;
    margin-right: 7px;
  }
`
